import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const Close = () => <ImageIcon src={Images.Close} alt="sh-logo-icon/" />;

export default Close;
